var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preparation-analysis-page__container"},[_c('PreparationAnalysisPageHeader'),(_vm.isPreparationCreated)?[_c('PreparationAnalysisChart'),_c('PreparationAnalysisTable')]:_c('EmptyAnalysisPlaceholder')],2)}
var staticRenderFns = []

export { render, staticRenderFns }